import { Route, Routes } from "react-router-dom";

import AppLayout from "@/components/AppLayout";
import RequireAuth from "@/components/RequireAuth";
import CipherCreator from "@/components/CipherCreator";
import Dashboard from "@/components/Dashboard";
import EmCrypter from "@/components/EmCrypter";
import VerificationManager from "@/components/VerificationManager";
import AuthCallback from "@/routes/AuthCallback";
import CipherDetail from "@/routes/CipherDetail";
import Landing from "@/routes/Landing";
import Login from "@/routes/Login";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <AppLayout>
              <Dashboard />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/create"
        element={
          <RequireAuth>
            <AppLayout>
              <CipherCreator />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/messages"
        element={
          <RequireAuth>
            <AppLayout>
              <EmCrypter />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/ciphers/:code"
        element={
          <RequireAuth>
            <AppLayout>
              <CipherDetail />
            </AppLayout>
          </RequireAuth>
        }
      />
      <Route
        path="/ciphers/:code/verifications"
        element={
          <RequireAuth>
            <AppLayout>
              <VerificationManager />
            </AppLayout>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
